<template>
  <div class="flex items-center w-full h-full">
    <template v-if="updating">
      <Spinner class="text-gray-600" />
    </template>
    <template v-else>
      <button
        v-if="on"
        type="button"
        @click="onClick"
      >
        <CheckCircleIcon class="h-6 w-6 text-blue-400" />
      </button>
      <button
        v-else
        type="button"
        @click="onClick"
      >
        <MinusCircleIcon class="h-6 w-6 text-red-400" />
      </button>
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { MinusCircleIcon, CheckCircleIcon } from '@heroicons-2/vue/24/outline'
import Spinner from '@/Components/Icons/Spinner.vue'

/**
 * @typedef {Object} LinkCellParams
 * @property {Function} submit
 */
const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const updating = ref(false)
const on = ref(props.params.value)

const onClick = () => {
  updating.value = true

  try {
    props.params.submit(!on.value)
    on.value = !on.value
  } catch (e) {
    console.error(e)
  } finally {
    updating.value = false
  }
}
</script>
